import { SearchOutlined } from '@ant-design/icons';
import { removeDiacritics } from '@mahawi/eshop-common/src/remove-diacritics';
import { type TableColumnType } from 'antd';
import { Button, Input, Space } from 'antd';
import { type FilterDropdownProps } from 'antd/es/table/interface';
import React, { type ChangeEvent } from 'react';

import { COLOR, SPACING } from '../theme/tokens';

export function getColumnSearchDropdown<T>(
  placeholder: string,
): Pick<TableColumnType<T>, 'filterDropdown' | 'filterIcon'> {
  return {
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }: FilterDropdownProps): React.ReactElement => (
      <div style={{ padding: SPACING.sm }}>
        <Input
          placeholder={placeholder}
          value={selectedKeys[0]}
          onChange={(e: ChangeEvent<HTMLInputElement>): void =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={(): void => confirm()}
          style={{ width: 188, marginBottom: SPACING.sm, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={(): void => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={(): void => clearFilters && clearFilters()}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean): React.ReactElement => (
      <SearchOutlined style={{ color: filtered ? COLOR.primary : undefined }} />
    ),
  };
}

export function getColumnSearch<T>(
  dataIndex: string,
  getValue?: (record: T) => string | null | undefined,
): TableColumnType<T> {
  return {
    ...getColumnSearchDropdown<T>(`Search ${dataIndex}`),
    onFilter: (value: string, record: T): boolean => {
      const rawValue: unknown = getValue ? getValue(record) : record[dataIndex];
      const recordValue: string = removeDiacritics(
        rawValue ? String(rawValue) : '',
      )
        .trim()
        .toLocaleLowerCase();
      const valuesToSearch: string[] = removeDiacritics(value)
        .trim()
        .toLocaleLowerCase()
        .split(' ');

      return valuesToSearch.every((searchValue: string): boolean =>
        recordValue.includes(searchValue),
      );
    },
  };
}
